<template>
  <v-app id="app">
    <VToastVue ref="vtoast"></VToastVue>
    <VLoadingVue ref="vloading"></VLoadingVue>
    <router-view />
  </v-app>
</template>

<script>
import VToastVue from "./components/commom/VToast.vue";
import VLoadingVue from "./components/commom/VLoading.vue";

export default {
  name: "App",
  components: {
    VToastVue,
    VLoadingVue
  },
  mounted() {
    this.$root.vtoast = this.$refs.vtoast;
    this.$root.vloading = this.$refs.vloading;
  },
};
</script> 

<style>
#app {

  font-family: Roboto, "Helvetica Neue", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #343636; */
  color: #2c3e50;
}

/* #f1f4f9; */

#app, #editForm{
  /* background-color: #343636; */
   background-color: #ECEFF1;
}
.row{
  margin:0px !important;
}
.footer{
    /* border-top: 1px solid #ffffff; */
    border-top: 1px solid #c9d3dd;
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;
    background-color: rgb(255, 254, 254);
}

 
 .inputs-container .col-12 {
    padding-top: 0;
    padding-bottom: 0;
  }

   .inputs-container .col-md-12 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .inputs-container .col-md-6 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .inputs-container .col-md-4 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .inputs-container .col-md-2 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .inputs-container .col-md-3 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .inputs-container .col-md-5 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .inputs-container .col-md-7 {
    padding-top: 0;
    padding-bottom: 0;
  }

  .inputs-container .col-md-8 {
    padding-top: 0;
    padding-bottom: 0;
  }
 
  .inputs-container .col-md-9 {
    padding-top: 0;
    padding-bottom: 0;
  }

 .inputs-container .theme--light.v-input {
    padding-top: 0;
  }

.inputs-container  .v-input__slot {
    margin-bottom: 0;
    
  }

div.v-card__title  {
    padding-top: 2px !important;
    padding-bottom: 0px !important;
}

.v-card .v-divider{
  margin-bottom: 11px;
}

.v-card__subtitle {
  padding-bottom: 5px !important;
}


.descricao-produto{
  text-align: left;
  list-style: none;
  
}

.required label::after {
    content: "*";
    color: red
}


.tippy-popper{
  font-family:   Roboto,  Helvetica, Arial, sans-serif;
}

.v-card__title + .v-card__subtitle {
    margin-top: 0px !important;
}

</style>


<style>
 @import    url("@/assets/resposta_azul.css"); 
 @import    url("@/assets/spc_boavista.css");    
</style>
